// src/utils/secureStorage.js

import CryptoJS from 'crypto-js'

// Your static AES secret (from .env)
const SECRET = process.env.REACT_APP_STORAGE_SECRET

// In-memory cache for decrypted values
const cache = new Map()

const secureStorage = {
  /**
   * Encrypt & store a value both in:
   *  • in-memory cache
   *  • sessionStorage (encrypted)
   */
  set(key, value) {
    try {
      // 1) Cache plaintext for fast in-memory reads
      cache.set(key, value)

      // 2) Encrypt & persist
      const ciphertext = CryptoJS.AES
        .encrypt(JSON.stringify(value), SECRET)
        .toString()

      // window.sessionStorage.setItem(key, ciphertext)
    } catch (e) {
      console.error('secureStorage.set error', e)
    }
  },

  /**
   * Retrieve a value:
   *  • if in cache, return immediately
   *  • otherwise decrypt from sessionStorage, prime cache, and return
   */
  get(key, defaultValue = null) {
    // 1) Fast path: in-memory cache
    if (cache.has(key)) {
      return cache.get(key)
    }

    // try {
    //   // 2) Encrypted blob from sessionStorage
    //   const ciphertext = window.sessionStorage.getItem(key)
    //   if (!ciphertext) {
    //     return defaultValue
    //   }

    //   // 3) Decrypt
    //   const bytes     = CryptoJS.AES.decrypt(ciphertext, SECRET)
    //   const decrypted = bytes.toString(CryptoJS.enc.Utf8)

    //   // 4) Parse JSON (fallback to string)
    //   let parsed
    //   try {
    //     parsed = JSON.parse(decrypted)
    //   } catch {
    //     parsed = decrypted
    //   }

    //   // 5) Prime cache & return
    //   cache.set(key, parsed)
    //   return parsed
    // } catch (e) {
    //   console.error('secureStorage.get error', e)
    //   return defaultValue
    // }
  },

  /**
   * Remove a single key from both cache and sessionStorage
   */
  remove(key) {
    cache.delete(key)
    window.sessionStorage.removeItem(key)
  },

  /**
   * Clear everything in both cache and sessionStorage
   */
  clear() {
    cache.clear()
    window.sessionStorage.clear()
  },
}

export default secureStorage
